import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import InsightsSection from '../Components/analyst/InsightsSection'
import FeaturedViews from '../Components/analyst/FeaturedViews'
import AbstractSection from '../Components/analyst/AbstractSection'
import KeyInsights from '../Components/analyst/KeyInsights'
import WhitePaperBanner from '../Components/analyst/WhitePaperBanner'
import { Helmet } from "react-helmet-async";

function AnalystDetail() {
  return (
    <div>
      <Helmet>
    <title>
        AI Agents & Enterprise Identity Management | Mobikode
    </title>

    <meta
        name="description"
        content="Explore how adaptive trust frameworks can help secure autonomous AI systems and address governance challenges in enterprise identity management."
    />

    <meta
        name="keywords"
        content="AI Agents, Enterprise Identity Management, AI Governance, Autonomous AI Systems, AI Security, Adaptive Trust Frameworks, Enterprise AI Security, Identity Management, AI Governance Gap, Microsoft AI, Tech Mahindra AI, Mobikode Analyst Insights"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/analyst-insights/ai-agents-enterprise-identity-management"
    />

    <meta
        property="og:title"
        content="AI Agents & Enterprise Identity Management | Mobikode"
    />

    <meta
        property="og:description"
        content="A Tech Mahindra and Microsoft perspective on securing autonomous AI systems through adaptive trust frameworks and addressing the enterprise governance gap."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/analyst-insights/ai-agents-enterprise-identity-management"
    />

    <meta
        property="og:type"
        content="article"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/analyst/bg2.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="AI Agents & Enterprise Identity Management | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore adaptive trust frameworks for securing autonomous AI systems and closing the enterprise governance gap."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/analyst/bg2.png"
    />
</Helmet>
      <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
        <div className="absolute inset-0 z-0">
          <img
            src="/assets/analyst/bg2.png"
            alt="Abstract 3D Background"
            className="w-full h-full object-cover"
          />
          <div
            style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
            className="hidden md:block absolute inset-0"
          ></div>
          <div
            style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
            className="block md:hidden absolute inset-0"
          ></div>
        </div>
        <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
          <div className="w-full max-w-[500px] lg:max-w-[980px] mt-auto md:mt-0">
            <p className="text-[#FFFFFF] max-w-[980px] w-full text-[20px] md:text-[30px] leading-[1.4] font-sora font-[600] tracking-wider text-left opacity-90 lg:opacity-100">
              AI Agents and Enterprise Identity Management: Closing the Governance Gap Securely
            </p>
            <p className="font-[500] font-graphik lg:text-[20px] text-[16px] lg:leading-[24px] leading-[20px] text-[#FFFFFF] pt-[30px]">A Tech Mahindra and Microsoft perspective on securing autonomous AI systems through adaptive trust frameworks.</p>
          </div>
        </div>
      </section>
      <AbstractSection />
      <KeyInsights />
      <WhitePaperBanner />
    </div>
  )
}

export default AnalystDetail
